import { render, staticRenderFns } from "./PageComponent.vue?vue&type=template&id=50eb964a&scoped=true"
import script from "./PageComponent.vue?vue&type=script&lang=js"
export * from "./PageComponent.vue?vue&type=script&lang=js"
import style0 from "./PageComponent.vue?vue&type=style&index=0&id=50eb964a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eb964a",
  null
  
)

export default component.exports